import { styled } from '../../utils';

export const TableStyled = styled('div')`
  width: 100%;
  display: table;
`;
